<template>
    <div class="global-realty-business-card">
        <el-form ref="globalRealtyCardForm" :model="form" label-width="80px" label-position="top">
            <el-form-item label="ChinessName">
                <el-input v-model="form.chineseName"></el-input>
            </el-form-item>
            <el-form-item label="EnglishName">
                <el-input v-model="form.englishName"></el-input>
            </el-form-item>

            <el-form-item label="EnglishTitle">
                <el-select v-model="form.englishTitle" placeholder="Select Title">
                    <el-option v-for="item in titleOptions" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ChinessTitle">
                <el-select v-model="form.chineseTitle" placeholder="Select Title">
                    <el-option v-for="item in titleOptions" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Phone Number">
                <el-input v-model="form.phoneNumber" @input="formatPhoneNumber"></el-input>
            </el-form-item>

            <el-form-item label="Email">
                <el-input v-model="form.email"></el-input>
            </el-form-item>

            <el-form-item label="Address">
                <el-input type="textarea" autosize placeholder="请输入地址，可换行" v-model="form.address">
                </el-input>
            </el-form-item>

            <el-form-item label="QR Code">
                <el-upload class="uploader" action="#" :auto-upload="false" :show-file-list="false"
                    :on-change="handleImage2Change">
                    <img v-if="form.image" :src="form.image" class="image">
                    <i v-else class="el-icon-plus uploader-icon"></i>
                </el-upload>
                <div class="el-form-item__tip" style="line-height: 1.2; margin-top: 4px;">
                    Please upload the black version of the QR code. The file size must not exceed 2MB.
                </div>
            </el-form-item>
        </el-form>

        <i class="fas fa-arrow-down" style="font-size: 35px; color: #b8b8b8"></i>

        <!-- 展示card区域 -->
        <div id="global-realty-card-section" style="display: flex; flex-direction: column; align-items: center;">
            <div id="global-realty-pdf-wrapper" class="global-realty-card-preview">
                <div id="global-realty-card-top" style="position: relative; width: 100%;">
                    <!-- 名片上部分png -->
                    <img src="/mkt_business_card/global_realty_head.jpg"
                        style="width: 100%; display: block; position: absolute; z-index: 1;">

                    <div id="nameAndTitleShowSection" style="position: absolute; top: 0; left: 0; z-index: 2;
                width: 100%; height: 100%; margin-left: 50px; margin-top: 38px;
                ">
                        <div>
                            <span class="chinese-name">{{ form.chineseName }}</span>
                            <span style="font-size: 20px; margin-left: 10px;" class="english-name">{{ form.englishName
                            }}</span>
                        </div>

                        <!-- 职位在第二行 -->
                        <div style="margin-top: 13px;">
                            <span style="font-size: 16px; " class="oppon-sans-regular">{{ form.chineseTitle }}</span>
                            <span style="font-size: 16px; margin-left: 10px; " class="oppon-sans-regular">{{
                                form.englishTitle }}</span>
                        </div>

                        <div style="margin-top: 50px; margin-left: 5px;">
                            <img v-if="form.image" :src="form.image" style="width: 18%; height: 18%;">
                        </div>
                    </div>

                    <div id="otherInfoShowSection" style="position: absolute; top: 170px; left: 194px; z-index: 2;
                width: 100%; height: 100%;">
                        <div><span style="font-size: 16px; margin-left: 10px; " class="oppon-sans-regular">{{
                            form.phoneNumber }}</span></div>
                        <div style="margin-top: 40px;">
                            <span style="font-size: 16px; margin-left: 10px; " class="oppon-sans-regular">{{ form.email
                            }}</span>
                        </div>
                        <!-- 将 margin-left 移动到父级 div，并改为 padding-left -->
                        <div style="margin-top: 40px; padding-left: 10px;">
                            <span style="font-size: 14px; white-space: pre-line;  letter-spacing: -0.7px;"
                                class="oppon-sans-regular">{{
                                form.address }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div id="pdf-footer-wrapper" style="width: 600px; background-color: #ffffff;">
                <!-- 名片下部分png -->
                <img src="/mkt_business_card/global_Realty_bg.jpg" style="width: 600px; display: block;">

            </div>

            <div>
                <span>
                    If you encounter any other problems or new requirements during the business card production process,
                    please contact MKT
                </span>
            </div>

            <el-button class="download-pdf-button" @click="generateHighQualityPDF"
                style="width: 300px; font-size: 20px; margin-top: 20px;">
                Download Business Card
            </el-button>
        </div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export default {
    name: 'GlobalRealtyBusinessCard',
    data() {
        return {
            titleOptions: [
                {
                    label: 'Sales Consultant',
                    value: 'Sales Consultant',
                },
                {
                    label: 'Property Manager',
                    value: 'Property Manager',
                },
                {
                    label: 'Senior Sales Consultant',
                    value: 'Senior Sales Consultant',
                },
            ],
            form: {
                chineseName: '张三',
                englishName: 'Aaaa Aaaa',
                chineseTitle: '销售总监',
                englishTitle: 'Sales Consultant',
                phoneNumber: '0488 888 888',
                email: 'awareglobal@gmail.com',
                address: 'Level 3, 370 Pitt Street',
                image: '',
            },
        };
    },
    computed: {
        displayEmail() {
            if (this.form.email) {
                return this.form.email;
            }

            return `${this.form.englishName.replace(/\s+/g, '').toLowerCase()}@globalrealty.com.au`;
        },
    },
    methods: {
        formatPhoneNumber(value) {
            if (!value) {
                this.form.phoneNumber = '';
                return;
            }

            let val = value.replace(/\D/g, '');
            val = val.substring(0, 10);

            let formatted = val;
            if (val.length > 4 && val.length <= 7) {
                formatted = `${val.slice(0, 4)} ${val.slice(4)}`;
            } else if (val.length > 7) {
                formatted = `${val.slice(0, 4)} ${val.slice(4, 7)} ${val.slice(7)}`;
            }

            this.form.phoneNumber = formatted;
        },

        handleImageChange(file) {
            if (!file || !file.raw) {
                this.$message.error('Invalid file!');
                return;
            }

            const isLt2M = file.raw.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('Uploaded profile picture size must not exceed 2MB!');
                return;
            }

            this.$set(this.form, 'image', URL.createObjectURL(file.raw));
        },

        handleImage2Change(file) {
            if (!file || !file.raw) {
                this.$message.error('Invalid file!');
                return;
            }

            const isLt2M = file.raw.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('Uploaded QR code image size must not exceed 2MB!');
                return;
            }

            this.$set(this.form, 'image', URL.createObjectURL(file.raw));
        },

        async generateHighQualityPDF() {
            const pdfWrapper = document.getElementById('global-realty-pdf-wrapper');
            const footerWrapper = document.getElementById('pdf-footer-wrapper');
            if (!pdfWrapper || !footerWrapper) {
                this.$message.error('Unfinished template detected.');
                return;
            }

            this.$message.info('Generating high-quality PDF...');

            await this.$nextTick();
            await document.fonts.ready;

            try {
                const canvasOptions = {
                    scale: 8,
                    useCORS: true,
                    allowTaint: true,
                    imageTimeout: 0,
                    removeContainer: true,
                    backgroundColor: '#ffffff',
                };

                const cardCanvas = await html2canvas(pdfWrapper, canvasOptions);
                const footerCanvas = await html2canvas(footerWrapper, canvasOptions);

                const cardImage = cardCanvas.toDataURL('image/jpeg', 0.98);
                const footerImage = footerCanvas.toDataURL('image/jpeg', 0.98);

                const scaleFactor = 90 / 600;
                const cardWidthMm = (cardCanvas.width / 8) * scaleFactor;
                const cardHeightMm = (cardCanvas.height / 8) * scaleFactor;
                const footerWidthMm = (footerCanvas.width / 8) * scaleFactor;
                const footerHeightMm = (footerCanvas.height / 8) * scaleFactor;

                const pdf = new jsPDF({
                    orientation: cardWidthMm > cardHeightMm ? 'landscape' : 'portrait',
                    unit: 'mm',
                    format: [cardWidthMm, cardHeightMm],
                });

                pdf.addImage(cardImage, 'JPEG', 0, 0, cardWidthMm, cardHeightMm);

                pdf.addPage([footerWidthMm, footerHeightMm], footerWidthMm > footerHeightMm ? 'landscape' : 'portrait');
                pdf.addImage(footerImage, 'JPEG', 0, 0, footerWidthMm, footerHeightMm);

                const filename = `Global_Realty_Card_${this.form.englishName.replace(/\s+/g, '_')}_${new Date().toISOString().slice(0, 10)}.pdf`;
                pdf.save(filename);

                this.$message.success('High-quality PDF generated successfully!');
            } catch (err) {
                console.error('PDF generation failed:', err);
                this.$message.error(`PDF generation failed: ${err.message}`);
            }
        },
    },
};
</script>

<style scoped>
.chinese-name {
    font-family: 'SourceHanSansSC', 'Microsoft YaHei', Arial, sans-serif;
    font-size: 22px;
    font-weight: 700;
}

.english-name {
    font-family: 'Gothic', 'Microsoft YaHei', Arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
}

.oppon-sans-bold {
    font-family: 'OpponSansBold', 'Microsoft YaHei', Arial, sans-serif;
    font-weight: 700;
    letter-spacing: -0.5px;

}

.oppon-sans-regular {
    font-family: 'OpponSansRegular', 'Microsoft YaHei', Arial, sans-serif;
    font-weight: 400;
}

.oppon-sans-regular {
    font-family: 'OpponSansRegular', 'Microsoft YaHei', Arial, sans-serif;
    font-weight: 400;
}

.global-realty-card-preview {
    width: 600px;
    height: 350px;
    background: #ffffff;
    box-shadow: none;
    box-sizing: border-box;
    color: #263126;
    font-family: Aptos, Arial, sans-serif;
    overflow: hidden;
}

.card-content {
    height: 100%;
    padding: 24px;
    box-sizing: border-box;
    position: relative;
}

.card-content::after {
    content: "";
    position: absolute;
    right: -70px;
    bottom: -95px;
    width: 260px;
    height: 260px;
    border: 34px solid #7d946e;
    border-radius: 50%;
    opacity: 0.24;
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
}

.logo {
    max-width: 180px;
    max-height: 64px;
    object-fit: contain;
}

.brand-label {
    color: #7d946e;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
}

.profile-section {
    display: flex;
    justify-content: space-between;
    gap: 26px;
    margin-top: 32px;
    position: relative;
    z-index: 1;
}

.profile-copy {
    min-width: 0;
    padding-top: 8px;
}

.name {
    color: #263126;
    font-size: 30px;
    font-weight: 700;
}

.title {
    color: #7d946e;
    font-size: 17px;
    margin-top: 6px;
}

.branch {
    font-size: 15px;
    font-weight: 700;
    margin-top: 34px;
}

.address {
    color: #556052;
    font-size: 14px;
    margin-top: 6px;
    max-width: 310px;
}

.portrait-frame {
    width: 142px;
    height: 178px;
    border: 1px solid #d9ded8;
    background: #f4f6f2;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.portrait,
.image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

.portrait-placeholder {
    color: #9ba694;
    font-size: 14px;
}

.contact-row {
    position: absolute;
    left: 24px;
    right: 24px;
    bottom: 22px;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    color: #263126;
    font-size: 12px;
}

.contact-row>div {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.image {
    width: 178px;
    height: 178px;
}
</style>
